module.exports = __webpack_public_path__ + "static/media/chargixpro-2.cd7e95f3.jpg";